import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpService} from '../../../common/api/http.service';
import {DataSource} from '@mominsamir/ngx-smart-table/lib/lib/data-source/data-source';
import {APIResponse, Filter} from '@core/interfaces/system/system-common';
import {HttpParams} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {LatestModelStatus} from '@core/interfaces/live/live';
import {ThicknessRateDashboardData, ThicknessRateUnits} from '@core/interfaces/live/thickness-rate';

@Injectable()
export class ThicknessRateApi {
    private readonly PREFIX = 'live/output/thickness-rate';

    constructor(private api: HttpService) {}

    public getThicknessRateUnits(): Observable<ThicknessRateUnits> {
        return this.api.get(`${this.PREFIX}/units`);
    }

    public getThicknessRateDatasource(id: string, filters: Filter[]): Observable<DataSource> {
        return this.api.postServerDataSource(`${this.PREFIX}/list?filterByassetId=${id}`, filters);
    }

    public getCountResults(assetId: string, uploadTime?: string): Observable<number> {
        return this.api
            .get(`${this.PREFIX}/count`, {
                params: new HttpParams().set('assetId', assetId || '').set('asOf', uploadTime || ''),
            })
            .pipe(map((res: APIResponse<number>) => res.response));
    }

    public getThicknessRateLatestModelStatus(assetId: string, uploadTime?: string): Observable<LatestModelStatus> {
        return this.api
            .get(`${this.PREFIX}/latest`, {
                params: new HttpParams().set('assetId', assetId || '').set('asOf', uploadTime || ''),
            })
            .pipe(map((res: APIResponse<LatestModelStatus>) => res.response));
    }

    public getThicknessRateDashboardData(
        chart: string,
        assetId: string,
        uploadTime?: string,
    ): Observable<ThicknessRateDashboardData> {
        return this.api
            .get(`${this.PREFIX}/data/${chart}`, {
                params: new HttpParams().set('assetId', assetId || '').set('asOf', uploadTime || ''),
            })
            .pipe(map((res: APIResponse<ThicknessRateDashboardData>) => res.response));
    }
}
